import Resources from "../../shared/actions/resourcesActions";

export class ProjectFeaturesResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "project_features", "/api/v1/project_features");
  }
}

export default ProjectFeaturesResource;
